<template>
    <div class="">
        <div class="text-sm" :class="[isError ? 'text-red-500' : 'text-gray-800']">
            {{inputLbl.name}}
        </div>
        <div class="relative pb-5 flex">
            <div class="flex py-1 items-center mr-12 cursor-pointer"
                 v-for="(item) in itemList"
                 :key="item.value"
                 @click="selectRadio(item.value)">
                <div class="flex-shrink-0">
                    <img class="radio-icon" v-if="item.value == content" src="../../../assets/radio/radio-active.svg"/>
                    <img class="radio-icon" v-else src="../../../assets/radio/radio-inactive.svg"/>
                </div>
                <div class="pl-2 text-16 text-a-brown-502314"
                     :class="{'error': isError}">
                    {{item.text}}
                </div>
            </div>
            <div class="text-red-500 text-sm absolute bottom-0 left-0 w-full" v-show="isError">
                {{errorInfo.msg}}
            </div>
        </div>
    </div>
</template>
<script>
/**
 * @property {String} v-model:inputValue (required) bind value
 * @property {Object} inputLbl (required) Text for component.
 * @property {Array} itemList (required) example : { text: '', value: ''}
 * @property {Object} errorInfo (required) Validate result. example : { isValid: true, msg: '',}
 * @property {Boolean} isShowError (optional) Show/Hide Error label.
 * @property {Boolean} isSubmitted (required) Show/Hide Error after save.
 */
export default {
    name: "InputRadio",
    props: {
        // v-model
        inputValue:     { type: String },
        itemList:       { type: Array, required: true },
        // props
        errorInfo:      { type: Object, required: true },
        isShowError:    { type: Boolean, default: false },
        isSubmitted:    { type: Boolean, default: false },
        // text
        inputLbl:       { type: Object, required: true },
    },
    data: function() {
        return {
            content: '',
            customClass: '',
        };
    },
    created: function() {
        this.customClass = this.addClass == null ? '' : this.addClass;
        this.content = this.inputValue;
        this.validate();
    },
    computed: {
        isError: function() {
            return (this.isShowError && this.isSubmitted && !this.errorInfo.isValid);
        },
    },
    methods: {
        selectRadio: function(value) {
            this.content = value;
            this.validate();
            this.$emit('update:inputValue', value);
        },
        validate: function() {
            if (!this.inputLbl) {
                return;
            }
            // set default.
            this.errorInfo.setValid(true);
            this.errorInfo.setMsg('');
            // required
            if (this.inputLbl.required && !this.content) {
                this.errorInfo.setValid(false);
                this.errorInfo.setMsg(this.inputLbl.required);
                return;
            }
        },
    },
}
</script>
<style lang="scss" scoped>
    .radio-icon {
        width: 22px;
    }
</style>
